import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { st, classes } from './SidePanel.st.css';
import Header from './Header';
import Content from './Content';
import Footer from './Footer';
import Divider from './Divider';
import { SidePanelContext } from './SidePanelAPI';
import { SidePanelProps } from './SidePanel.types';
import Section from './Section';
import Field from './Field';

class SidePanel extends PureComponent<SidePanelProps> {
  static displayName = 'SidePanel';

  static Header = Header;
  static Content = Content;
  static Footer = Footer;
  static Divider = Divider;
  static Section = Section;
  static Field = Field;

  static propTypes = {
    className: PropTypes.string,
    dataHook: PropTypes.string,
    onCloseButtonClick: PropTypes.func,
    onHelpButtonClick: PropTypes.func,
    children: PropTypes.node,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    maxHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    skin: PropTypes.oneOf(['standard', 'floating']),
    draggable: PropTypes.bool,
  };

  static defaultProps = {
    width: '420px',
    height: '100%',
  };

  render() {
    const {
      dataHook,
      skin = 'standard',
      children,
      className,
      width,
      height,
      maxHeight,
      onCloseButtonClick,
      onHelpButtonClick,
      draggable,
    } = this.props;
    const isDraggable = draggable && skin === 'floating';
    return (
      <SidePanelContext.Provider
        value={{ onCloseButtonClick, onHelpButtonClick, skin, isDraggable }}
      >
        <div
          className={st(classes.root, { skin }, className)}
          data-hook={dataHook}
          style={{ width, height, maxHeight }}
        >
          {children}
        </div>
      </SidePanelContext.Provider>
    );
  }
}

export default SidePanel;
